import { RelatedTermTypes } from '../shared/components/styled/search/types';
import { Entity, EntityType, TermRelationshipType } from '../../../types.generated';
import EntityRegistry from '../EntityRegistry';

export function sortGlossaryTerms(entityRegistry: EntityRegistry, nodeA?: Entity | null, nodeB?: Entity | null) {
    const nodeAName = entityRegistry.getDisplayName(EntityType.GlossaryTerm, nodeA) || '';
    const nodeBName = entityRegistry.getDisplayName(EntityType.GlossaryTerm, nodeB) || '';
    return nodeAName.localeCompare(nodeBName);
}

export function getRelatedEntitiesUrl(entityRegistry: EntityRegistry, urn: string) {
    return `${entityRegistry.getEntityUrl(EntityType.GlossaryTerm, urn)}/${encodeURIComponent('Related Entities')}`;
}

// Check if the relationship type is editable
export function checkIsEditable(type: string) {
    const allowedTypes = [
        RelatedTermTypes.isRelatedTerms,
        RelatedTermTypes.hasRelatedTerms,
        RelatedTermTypes.typeOfRelations,
    ];
    return allowedTypes.includes(RelatedTermTypes[type]);
}

export function isTypeOf(relationshipType = '') {
    return relationshipType === RelatedTermTypes.typeOfRelations;
}

export function getRelationshipType(relationshipType = '') {
    if (isTypeOf(relationshipType)) {
        return RelatedTermTypes.typeOfRelations;
    }

    return relationshipType === RelatedTermTypes.hasRelatedTerms ? TermRelationshipType.HasA : TermRelationshipType.IsA;
}
